import {Component, Input} from '@angular/core';
import {FeedClub} from "../../feed-club/feed-club.component";
import {ClubMembersListPage} from "../../network/club-member-list/club-member-list";
import {ClubPopoverComponent} from "../../../../components/club-popover/club-popover";
import {ModalController, PopoverController} from "ionic-angular";

/**
 * Generated class for the ProfileClubsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'profile-clubs',
  templateUrl: 'profile-clubs.html'
})
export class ProfileClubs{

  @Input() myClubs;
  @Input() currUserId;

  constructor(private modalCtrl: ModalController,
              private popoverCtrl: PopoverController) {

  }

  seeFeedClub(club) {
    let modal = this.modalCtrl.create(FeedClub, {club: club});
    modal.present().then(() => {});
  }

  showMembers(clubId){
    let modal = this.modalCtrl.create(ClubMembersListPage, {clubId: clubId})
    modal.present().then(() => {});
  }

  presentPopover(event, clubId) {

    let popover = this.popoverCtrl.create(ClubPopoverComponent, {clubId: clubId, userId: this.currUserId, isUserOwner: true}, {
      cssClass: 'my-popover'
    });
    popover.onDidDismiss(() => {
    });
    popover.present({
      ev: event
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/profile/profile-clubs/profile-clubs.ts